import { render, staticRenderFns } from "./ProposalNoContent.vue?vue&type=template&id=20a25146&scoped=true"
import script from "./ProposalNoContent.vue?vue&type=script&lang=js"
export * from "./ProposalNoContent.vue?vue&type=script&lang=js"
import style0 from "./ProposalNoContent.vue?vue&type=style&index=0&id=20a25146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a25146",
  null
  
)

export default component.exports